<div class="container">
    <h2 mat-dialog-title class="cut-long-text">
        @if (!data.hasId()) {
            Neuer Datensatz
        } @else {
            Datensatz bearbeiten
        }
    </h2>
    <mat-divider></mat-divider>
    <form [formGroup]="formGroup" class="pixl-form">
        <mat-dialog-content>
                <br />
                <div>
                    <mat-form-field>
                        <mat-label>Titel</mat-label>
                        <input matInput formControlName="title" />
                        @if (formGroup.get("title")?.hasError("required")) {
                            <mat-error>Titel ist erforderlich</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field>
                        <mat-label>Untertitel</mat-label>
                        <input matInput formControlName="subtitle" />
                    </mat-form-field>
                </div>
                <div class="content-container">
                    <div>Vorschaubild</div>
                    <div>
                        <button
                            class="extend-button"
                            mat-stroked-button
                            (click)="openImageChoice()"
                        >
                            <mat-icon>add_photo_alternate</mat-icon>
                            Bild aus Medien
                        </button>
                        @if (getImageName() && getImageName().length > 0) {
                            <span class="info cut-long-text">{{
                                getImageName()
                            }}</span>
                        }
                        <br />
                    </div>
                    <div>
                        @if (getImageName() && getImageName().length > 0) {
                            <div class="media-container">
                                <div class="media-item">
                                    <button
                                        mat-icon-button
                                        matTooltip="Bild-Datei löschen"
                                        class="button-delete"
                                        (click)="deleteMediaEntry()"
                                    >
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                </div>
                                <div class="media-item">
                                    <img
                                        src="{{ imageUrl() }}"
                                        alt=""
                                        class="preview"
                                    />
                                </div>
                            </div>
                        }
                    </div>
                </div>
                <div>
                    <br />
                    <mat-form-field>
                        <mat-label>Unterrichtsphase</mat-label>
                        <input matInput formControlName="lesson_section" />
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field>
                        <mat-label>Bearbeitungszeit</mat-label>
                        <input
                            matInput
                            type="number"
                            formControlName="processing_time"
                        />
                    </mat-form-field>
                </div>
                <div class="filter-item">
                    <pixl-state-cb
                        [required]="true"
                        [initValue]="status"
                        (onStateChange)="statusChanged($event)"
                    />
                </div>
                <div>
                    <pixl-federal-states-combobox
                        [initValue]="federal_states"
                        (initValueChange)="federalStatesChanged($event)"
                    />
                </div>
                <div>
                    <mat-form-field>
                        <mat-label>Lerneinheits-Ziel</mat-label>
                        <mat-select formControlName="learning_unit_goal">
                            <mat-option value="voluntarily"
                                >Freiwillig</mat-option
                            >
                            <mat-option value="mandatory"
                                >Verpflichtend</mat-option
                            >
                        </mat-select>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field>
                        <mat-label>Lerneinheits-Typ</mat-label>
                        <input matInput formControlName="learning_unit_type" />
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field>
                        <mat-label>Beschreibung</mat-label>
                        <textarea
                            matInput
                            formControlName="description"
                        ></textarea>
                    </mat-form-field>
                </div>

            <div class="border-area full-width">
                <div class="learning-unit-select mt-2">
                    <pixl-multi-combo-search
                        [label]="'Lernabschnitte'"
                        [observable$]="learningSections$"
                        [namingColumn]="'name'"
                        [externalSearch]="true"
                        (onStateChange)="receiveData($event)"
                        (onSearchChange)="receiveSearchQuery($event)"
                        [(selectedValues)]="learningSections"
                     />
                </div>

                <div class="mb-1">Anordnen (Drag'n Drop)</div>
                <div
                    cdkDropList
                    class="learning-section-list"
                    (cdkDropListDropped)="reorderLearningSections($event)"
                >
                    @for (
                        learningSection of formGroup.get("learningSections")?.value;
                        track learningSection.id
                    ) {
                        <div class="learning-section-box" cdkDrag>
                            {{ learningSection.title }}
                        </div>
                    }
                </div>
            </div>
        </mat-dialog-content>
    </form>
    <mat-divider></mat-divider>
    <div mat-dialog-actions>
        <button mat-raised-button (click)="onCancel()">Abbrechen</button>
        <button mat-raised-button color="primary" (click)="onSave()">
            Speichern
        </button>
    </div>
</div>
